const reprovedProcess = (processStats) => {
  return processStats?.departments?.reduce(
    (value, department) => value + department.statuses?.disapproved,
    0,
  )
}

export default reprovedProcess
